<template>
  <div>
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a
          @click="handleStep('ANOTACAO_ENFERMAGEM')"
          :class="[
            'nav-link link-nav-resident',
            step == 'ANOTACAO_ENFERMAGEM' && 'active',
          ]"
          id="nav-anotacao"
          data-toggle="tab"
          href="#anotacao"
          role="tab"
          aria-controls="anotacao"
          aria-selected="true"
          >ANOTAÇÃO DE CUIDADOS</a
        >
        <a
          @click="handleStep('CHECAGEM_MEDICAMENTOS')"
          :class="[
            'nav-link link-nav-resident',
            step == 'CHECAGEM_MEDICAMENTOS' && 'active',
          ]"
          id="nav-checagem"
          data-toggle="tab"
          href="#checagem"
          role="tab"
          aria-controls="checagem"
          aria-selected="true"
          >CHECAGEM DE MEDICAMENTOS</a
        >
        <a
          @click="handleStep('SEMIOLOGIA')"
          :class="[
            'nav-link link-nav-resident',
            step == 'SEMIOLOGIA' && 'active',
          ]"
          id="nav-semiologia"
          data-toggle="tab"
          href="#semiologia"
          role="tab"
          aria-controls="semiologia"
          aria-selected="true"
          >SEMIOLOGIA</a
        >
        <a
          @click="handleStep('MEDICAMENTOS_SEPARADOS')"
          :class="[
            'nav-link link-nav-resident',
            step == 'MEDICAMENTOS_SEPARADOS' && 'active',
          ]"
          id="nav-medicamentos_separados"
          data-toggle="tab"
          href="#medicamentos_separados"
          role="tab"
          aria-controls="medicamentos_separados"
          aria-selected="true"
          >MEDICAMENTOS SEPARADOS E NÃO CHECADOS
        </a>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div
        v-if="step == 'ANOTACAO_ENFERMAGEM'"
        :class="[
          'tab-pane fade',
          step == 'ANOTACAO_ENFERMAGEM' && 'show active',
        ]"
        id="anotacao"
        role="tabpanel"
        aria-labelledby="nav-anotacao"
      >
        <annotation
          :resident="resident"
          @pendingVerification="pendingVerification"
        />
      </div>
      <div
        v-if="step == 'CHECAGEM_MEDICAMENTOS'"
        :class="[
          'tab-pane fade',
          step == 'CHECAGEM_MEDICAMENTOS' && 'show active',
        ]"
        id="checagem"
        role="tabpanel"
        aria-labelledby="nav-checagem"
      >
        <check
          :resident="resident"
          @pendingVerification="pendingVerification"
        />
      </div>
      <div
        v-if="step == 'SEMIOLOGIA'"
        :class="['tab-pane fade', step == 'SEMIOLOGIA' && 'show active']"
        id="semiologia"
        role="tabpanel"
        aria-labelledby="nav-semiologia"
      >
        <semiology
          :resident="resident"
          @pendingVerification="pendingVerification"
        />
      </div>
      <div
        v-if="step == 'MEDICAMENTOS_SEPARADOS'"
        :class="[
          'tab-pane fade',
          step == 'MEDICAMENTOS_SEPARADOS' && 'show active',
        ]"
        id="MEDICAMENTOS_SEPARADOS"
        role="tabpanel"
        aria-labelledby="nav-medicamentos_separados"
      >
        <Separate_medications
          :resident="resident"
          @pendingVerification="pendingVerification"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Annotation from "./pending-verification/annoation.vue";
import Check from "./pending-verification/check.vue";
import Semiology from "./pending-verification/semiology.vue";
import Separate_medications from "./pending-verification/separate_medications.vue";

import routes from "../../routes";

export default {
  name: "MenuOrder",

  components: {
    Annotation,
    Check,
    Semiology,
    Separate_medications,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      step: "ANOTACAO_ENFERMAGEM",

      resident_id: "",
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    handleStep(step) {
      let newNav;

      if (step == "ANOTACAO_ENFERMAGEM") {
        newNav = "annotation";
      } else if (step == "CHECAGEM_MEDICAMENTOS") {
        newNav = "check";
      } else if (step == "SEMIOLOGIA") {
        newNav = "semiology";
      } else if (step == "MEDICAMENTOS_SEPARADOS") {
        newNav = "separate_medications";
      }

      let { tab, nav } = routes.history.current.query;

      if (nav != newNav) {
        routes.replace({ query: { tab, nav: newNav } });
      }

      this.step = step;
    },

    async retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;

      const { nav } = routes.history.current.query;

      if (nav) {
        if (nav == "annotation") {
          this.step = "ANOTACAO_ENFERMAGEM";
        } else if (nav == "check") {
          this.step = "CHECAGEM_MEDICAMENTOS";
        } else if (nav == "semiology") {
          this.step = "SEMIOLOGIA";
        } else {
          this.step = "ANOTACAO_ENFERMAGEM";
        }
      }
    },

    pendingVerification(item) {
      this.$emit("pendingVerification", item);
    },
  },
};
</script>
